import { AspectRatio } from '@chakra-ui/react';
import Hero from '~/components/Hero';
import { HERO_TYPE } from '~/components/Hero/constants';
import HtmlParser from '~/components/HtmlParser/HtmlParser';
import Layout from '~/components/Layout';
import SectionWithTitle from '~/components/SectionWithTitle';
import SEO from '~/components/SEO';
import { getCurrentOrigin } from '~/utils/getCurrentDomain';
import { getSeoDataFromWordpressForPage } from '~/utils/getSeoData';
import { createImageWithArtDirection } from '~/utils/imageUtils';
import React from 'react';

var PageRdv = function PageRdv(props) {
  var _contentTypeData$lang, _contentTypeData$lang2, _acfData$hero, _acfData$hero$desktop, _acfData$hero$desktop2, _acfData$hero$desktop3, _acfData$hero$desktop4, _acfData$hero2, _acfData$hero3, _acfData$hero4;

  var data = props.data;
  var pageContext = props.pageContext;
  var contentTypeData = data.wpPage;
  var acfData = contentTypeData === null || contentTypeData === void 0 ? void 0 : contentTypeData.acfRdv;
  if (!contentTypeData || !acfData || !(contentTypeData !== null && contentTypeData !== void 0 && contentTypeData.link) || !((_contentTypeData$lang = contentTypeData.language) !== null && _contentTypeData$lang !== void 0 && _contentTypeData$lang.slug) || !pageContext.defaultLanguage) return null;
  var seoProps = getSeoDataFromWordpressForPage({
    availableTranslations: contentTypeData.translations,
    currentLanguage: (_contentTypeData$lang2 = contentTypeData.language) === null || _contentTypeData$lang2 === void 0 ? void 0 : _contentTypeData$lang2.locale,
    currentOrigin: getCurrentOrigin(),
    defaultLanguage: pageContext.defaultLanguage,
    featuredImageUrl: (_acfData$hero = acfData.hero) === null || _acfData$hero === void 0 ? void 0 : (_acfData$hero$desktop = _acfData$hero.desktopFeaturedImage) === null || _acfData$hero$desktop === void 0 ? void 0 : (_acfData$hero$desktop2 = _acfData$hero$desktop.localFile) === null || _acfData$hero$desktop2 === void 0 ? void 0 : (_acfData$hero$desktop3 = _acfData$hero$desktop2.childImageSharp) === null || _acfData$hero$desktop3 === void 0 ? void 0 : (_acfData$hero$desktop4 = _acfData$hero$desktop3.gatsbyImageData) === null || _acfData$hero$desktop4 === void 0 ? void 0 : _acfData$hero$desktop4.src,
    pagePath: props.location.pathname,
    pageSlug: contentTypeData.slug,
    seo: contentTypeData.seo
  });
  var imageWithArtDirection = createImageWithArtDirection({
    desktopImage: (_acfData$hero2 = acfData.hero) === null || _acfData$hero2 === void 0 ? void 0 : _acfData$hero2.desktopFeaturedImage,
    mobileImage: (_acfData$hero3 = acfData.hero) === null || _acfData$hero3 === void 0 ? void 0 : _acfData$hero3.mobileFeaturedImage
  });
  var CALENDLY_TITLE = 'calendly';
  return /*#__PURE__*/React.createElement(Layout, {
    currentLanguage: contentTypeData.language,
    currentPath: contentTypeData.link,
    menuData: pageContext.menus,
    siteSettings: pageContext.siteSettings,
    translations: contentTypeData.translations
  }, /*#__PURE__*/React.createElement(SEO, seoProps), /*#__PURE__*/React.createElement(Hero, {
    backgroundImage: imageWithArtDirection,
    couleurTitre: "#000",
    type: HERO_TYPE.STATIC,
    heading: (_acfData$hero4 = acfData.hero) === null || _acfData$hero4 === void 0 ? void 0 : _acfData$hero4.title,
    size: "short"
  }), /*#__PURE__*/React.createElement(SectionWithTitle, {
    maxWidth: "900px",
    contentAlignment: "flex-start"
  }, /*#__PURE__*/React.createElement(HtmlParser, {
    textBlock: true,
    textAlign: "left"
  }, acfData.introduction), /*#__PURE__*/React.createElement(AspectRatio, {
    ratio: {
      base: 0.75,
      md: 4 / 3
    },
    width: "100%",
    mb: 8
  }, /*#__PURE__*/React.createElement("iframe", {
    title: CALENDLY_TITLE,
    src: "https://calendly.com/langtra?hide_landing_page_details=1"
  }))));
};

export default PageRdv;
var query = "3446568123";